import { type UseQueryResult, useQuery } from 'react-query';
import { TableParams } from '../../types/common';
import {
  PagedResultDto_ScheduleItemDto,
  ScheduleService,
} from '@wealthlane/api-services/wealthlane-job-scheduler-service';

const useGetJobSchedules = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  tableInfo: TableParams
): UseQueryResult<PagedResultDto_ScheduleItemDto | undefined, unknown> => {
  const {
    filter,
    sorting,
    skipCount,
    maxResultCount,
    fromCreatedDate,
    toCreatedDate,
    status,
    taskType,
    timeZone,
  } = tableInfo;

  const getJobSchedules = useQuery(
    [
      'getJobSchedules',
      fromCreatedDate,
      toCreatedDate,
      status,
      taskType,
      filter,
      sorting,
      skipCount,
      maxResultCount,
      timeZone,
    ],
    async () => {
      return await handleRequest(
        ScheduleService.getApiSchedulerApiAppSchedule(
          fromCreatedDate,
          toCreatedDate,
          undefined,
          taskType ? [taskType] : undefined,
          status ? [status] : undefined,
          timeZone,
          filter,
          sorting,
          skipCount,
          maxResultCount
        )
      );
    }
  );

  return getJobSchedules;
};

export default useGetJobSchedules;
